import { mpsEndpoints } from "../mps/mps-endpoints";

export const environment = {
  production: false,
  loginForm: false,
  api: {
    host: 'https://api-d.fluidipriced.iasp.tgscloud.net',
    providers: mpsEndpoints.providers
    //host: 'http://localhost:8000',
  },
   
  envName: 'develop',
  loaderOnHttp: true,
  defaultLocale: 'en',
  allowedLanguage: ['en'],
  translateConfig: {
    prefix: './assets/i18n/', suffix: '.json'
  },
  appName: 'MPS Bootstrap',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle', 'search'],
  appIcons: [],
  translationsSource: 'local',
  allowImpersonation: false,
};
